import React from "react";

const WarningIconWithOutline = (props) => {
    const {color = "#064A9B", ...rest} = props;
    return (
        <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <path
                d="M12.1271 3.454C13.8138 3.4538 15.4627 3.95379 16.8653 4.89074C18.2678 5.82769 19.361 7.15951 20.0067 8.71778C20.6523 10.2761 20.8213 11.9908 20.4924 13.6451C20.1634 15.2995 19.3513 16.8191 18.1587 18.0119C16.966 19.2046 15.4465 20.0169 13.7922 20.3461C12.1379 20.6752 10.4232 20.5064 8.86481 19.8609C7.30646 19.2155 5.97451 18.1224 5.0374 16.72C4.10029 15.3176 3.6001 13.6687 3.6001 11.982C3.60275 9.72105 4.50208 7.55345 6.10082 5.95472C7.69956 4.35598 9.86715 3.45665 12.1281 3.454H12.1271ZM12.1281 1.954C10.1448 1.954 8.20594 2.54213 6.55684 3.64402C4.90775 4.74591 3.62243 6.31207 2.86344 8.14445C2.10444 9.97683 1.90585 11.9931 2.29279 13.9384C2.67972 15.8836 3.63479 17.6704 5.03724 19.0729C6.43968 20.4753 8.2265 21.4304 10.1717 21.8173C12.117 22.2042 14.1333 22.0057 15.9657 21.2467C17.798 20.4877 19.3642 19.2024 20.4661 17.5533C21.568 15.9042 22.1561 13.9654 22.1561 11.982C22.1561 10.665 21.8967 9.36094 21.3927 8.14422C20.8887 6.9275 20.1499 5.82198 19.2186 4.89078C18.2873 3.95958 17.1817 3.22094 15.965 2.71705C14.7482 2.21315 13.4441 1.95387 12.1271 1.954H12.1281Z"
                fill={color}
            />
            <path
                d="M12.127 6.531V13.64"
                stroke={color}
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <path
                d="M12.127 18.131C12.6792 18.131 13.127 17.6833 13.127 17.131C13.127 16.5787 12.6792 16.131 12.127 16.131C11.5747 16.131 11.127 16.5787 11.127 17.131C11.127 17.6833 11.5747 18.131 12.127 18.131Z"
                fill={color}
            />
        </svg>
    );
};
export default WarningIconWithOutline;
